'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.List = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _entities = require('entities');

var _entities2 = _interopRequireDefault(_entities);

var _reactGa = require('react-ga');

var _reactGa2 = _interopRequireDefault(_reactGa);

var _More = require('../components/More');

var _More2 = _interopRequireDefault(_More);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _sanitizeHtml = require('sanitize-html');

var _sanitizeHtml2 = _interopRequireDefault(_sanitizeHtml);

var _truncate = require('truncate');

var _truncate2 = _interopRequireDefault(_truncate);

var _reactDfp = require('react-dfp');

var _index = require('../constants/index');

var _index2 = require('../utils/index');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

if (process.env.BROWSER) {
  require('./LatestArticles.css');
}

var List = function (_Component) {
  _inherits(List, _Component);

  function List(props, context) {
    _classCallCheck(this, List);

    var _this = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, props, context));

    _this._handleClick = _this._handleClick.bind(_this);
    _this.renderTitle = _this.renderTitle.bind(_this);
    _this.renderAD = _this.renderAD.bind(_this);
    return _this;
  }

  _createClass(List, [{
    key: '_handleClick',
    value: function _handleClick() {
      _reactGa2.default.event({
        category: this.props.pathName,
        action: 'click',
        label: 'list'
      });
    }
  }, {
    key: 'renderTitle',
    value: function renderTitle() {
      var title = _lodash2.default.get(this.props, 'title');

      return title ? _react2.default.createElement(
        'div',
        { className: 'ui text container', style: { marginBottom: '35px', paddingLeft: '1em !important', marginLeft: '0 !important' } },
        _react2.default.createElement(
          'div',
          { className: 'article-main', style: { textAlign: 'center' } },
          _react2.default.createElement(
            'h2',
            { className: 'hot-topic' },
            _react2.default.createElement('div', { className: 'colorBlock choice' }),
            title,
            _react2.default.createElement('div', { className: 'blue-line', style: { marginLeft: '16px', display: 'inline-block' } })
          )
        )
      ) : null;
    }
  }, {
    key: 'renderAD',
    value: function renderAD() {
      var sectionName = _lodash2.default.get(this.props, 'section');
      return _react2.default.createElement(
        'div',
        { className: 'computer-hide', style: { margin: '0 auto', 'marginBottom': '20px', 'maxWidth': '300px', textAlign: 'center' } },
        _react2.default.createElement(_reactDfp.AdSlot, { sizes: [[300, 250]],
          dfpNetworkId: _index.DFPID,
          slotId: 'mm_mobile_' + _index.AD_UNIT_PREFIX[sectionName] + '_300x250_L1',
          adUnit: 'mm_mobile_' + _index.AD_UNIT_PREFIX[sectionName] + '_300x250_L1',
          sizeMapping: [{ viewport: [1, 1], sizes: [[300, 250]] }, { viewport: [970, 200], sizes: [] }]
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props;
      var articles = _props.articles;
      var categories = _props.categories;
      var hasMore = _props.hasMore;
      var loadMore = _props.loadMore;

      var sortedArticles = _lodash2.default.sortBy(articles, function (o) {
        return new Date(o.publishedDate);
      }).reverse();

      return _react2.default.createElement(
        'div',
        { className: 'container' },
        this.renderTitle(),
        _react2.default.createElement(
          'div',
          { className: 'latest' },
          _lodash2.default.map(_lodash2.default.take(sortedArticles, 5), function (a, i) {
            var image = (0, _index2.imageComposer)(a).mobileImage;
            var title = (0, _sanitizeHtml2.default)(_lodash2.default.get(a, ['title'], ''), { allowedTags: [] });
            var linkStyle = _lodash2.default.get(a, 'style', '') == 'projects' ? '/projects/' : '/story/';
            var brief = (0, _sanitizeHtml2.default)(_lodash2.default.get(a, ['brief', 'html'], ''), { allowedTags: [] });
            var content = (0, _sanitizeHtml2.default)(_lodash2.default.get(a, ['content', 'html'], ''), { allowedTags: [] });
            var briefContent = brief.length > 0 ? brief : content;
            if (_lodash2.default.has(a, '_highlightResult')) {
              title = (0, _sanitizeHtml2.default)(_lodash2.default.get(a, ['_highlightResult', 'title', 'value'], ''), { allowedTags: ['em'] });
              brief = (0, _sanitizeHtml2.default)(_lodash2.default.get(a, ['_highlightResult', 'brief', 'value'], ''), { allowedTags: ['em'] });
              content = (0, _sanitizeHtml2.default)(_lodash2.default.get(a, ['_highlightResult', 'content', ' value'], ''), { allowedTags: ['em'] });
              briefContent = brief.length > 0 ? brief : content;
            }

            return _react2.default.createElement(
              'div',
              { className: 'latest-block', key: a.id || a._id },
              _react2.default.createElement(
                'a',
                { href: linkStyle + a.slug + '/', onClick: _this2._handleClick },
                _react2.default.createElement('div', { className: 'latest-img', style: { background: 'url(' + image + ') no-repeat center center', backgroundSize: 'cover' } })
              ),
              _react2.default.createElement(
                'div',
                { className: 'latest-content' },
                _react2.default.createElement(
                  'a',
                  { href: linkStyle + a.slug + '/', onClick: _this2._handleClick },
                  _react2.default.createElement(
                    'h2',
                    null,
                    _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: title } }),
                    _react2.default.createElement(
                      'div',
                      { className: 'cat-label' },
                      _react2.default.createElement('div', { className: 'separator' }),
                      _react2.default.createElement(
                        'span',
                        null,
                        _lodash2.default.get(a, ['categories', 0, 'title'], '')
                      )
                    )
                  )
                ),
                _react2.default.createElement('div', { className: 'line' }),
                _react2.default.createElement(
                  'div',
                  { className: 'brief' },
                  _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: (0, _sanitizeHtml2.default)((0, _truncate2.default)(_entities2.default.decodeHTML(briefContent), 75), { allowedTags: ['em'] }) } })
                )
              )
            );
          }),
          this.renderAD(),
          _lodash2.default.map(_lodash2.default.slice(sortedArticles, 5), function (a, i) {
            var image = (0, _index2.imageComposer)(a).mobileImage;
            var title = (0, _sanitizeHtml2.default)(_lodash2.default.get(a, ['title'], ''), { allowedTags: [] });
            var linkStyle = _lodash2.default.get(a, 'style', '') == 'projects' ? '/projects/' : '/story/';
            var brief = (0, _sanitizeHtml2.default)(_lodash2.default.get(a, ['brief', 'html'], ''), { allowedTags: [] });
            var content = (0, _sanitizeHtml2.default)(_lodash2.default.get(a, ['content', 'html'], ''), { allowedTags: [] });
            var briefContent = brief.length > 0 ? brief : content;
            if (_lodash2.default.has(a, '_highlightResult')) {
              title = (0, _sanitizeHtml2.default)(_lodash2.default.get(a, ['_highlightResult', 'title', 'value'], ''), { allowedTags: ['em'] });
              brief = (0, _sanitizeHtml2.default)(_lodash2.default.get(a, ['_highlightResult', 'brief', 'value'], ''), { allowedTags: ['em'] });
              content = (0, _sanitizeHtml2.default)(_lodash2.default.get(a, ['_highlightResult', 'content', ' value'], ''), { allowedTags: ['em'] });
              briefContent = brief.length > 0 ? brief : content;
            }

            return _react2.default.createElement(
              'div',
              { className: 'latest-block', key: a.id || a._id },
              _react2.default.createElement(
                'a',
                { href: linkStyle + a.slug + '/' },
                _react2.default.createElement('div', { className: 'latest-img', style: { background: 'url(' + image + ') no-repeat center center', backgroundSize: 'cover' } })
              ),
              _react2.default.createElement(
                'div',
                { className: 'latest-content' },
                _react2.default.createElement(
                  'a',
                  { href: linkStyle + a.slug + '/' },
                  _react2.default.createElement(
                    'h2',
                    null,
                    _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: title } }),
                    _react2.default.createElement(
                      'div',
                      { className: 'cat-label' },
                      _react2.default.createElement('div', { className: 'separator' }),
                      _react2.default.createElement(
                        'span',
                        null,
                        _lodash2.default.get(a, ['categories', 0, 'title'], '')
                      )
                    )
                  )
                ),
                _react2.default.createElement('div', { className: 'line' }),
                _react2.default.createElement(
                  'div',
                  { className: 'brief' },
                  _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: (0, _sanitizeHtml2.default)((0, _truncate2.default)(_entities2.default.decodeHTML(briefContent), 75), { allowedTags: ['em'] }) } })
                )
              )
            );
          })
        ),
        hasMore ? _react2.default.createElement(_More2.default, { loadMore: loadMore }) : null
      );
    }
  }]);

  return List;
}(_react.Component);

exports.default = List;
exports.List = List;


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/List.jsx
 ** module id = 116
 ** module chunks = 0
 **/